import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import InstructionCard from './components/InstructionCard';
import SwipeForm from './components/SwipeForm';
import TermsAgreement from './components/TermsAgreement';
import { useState } from 'react';
import './App.css';

const theme = createTheme({
  direction: "rtl",
  typography: {
    fontFamily: "Tajawal, Arial, sans-serif",
    fontSize: 18,
  },
  palette: {
    primary: { main: "#1976d2" },
    secondary: { main: "#ff4081" },
  },
});

function App() {
  const [agreed, setAgreed] = useState(false);
  const [showApp, setShowApp] = useState(false);
  const methods = useForm();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div dir="rtl">
        <FormProvider {...methods}>
          {!agreed && (
            <TermsAgreement onAgree={() => setAgreed(true)} />
          )}

          {agreed && !showApp && (
            <InstructionCard onAcknowledge={() => setShowApp(true)} />
          )}

          {showApp && <SwipeForm />}
        </FormProvider>
      </div>
    </ThemeProvider>
  );
}

export default App;
